<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Jupiter</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Rhett Heath</p>
<p class="P_Normal"> </p>
<p class="P_Normal">For fourteen-year-old Jacob Thomas, a Christian and the smartest kid in class, Bobby Versailles is completely out of reach. Jacob wishes a girl named Allie loved him because he still doesn’t get that he’s gay, but he always keeps his eyes peeled at school, hoping to catch a glimpse of Bobby.</p>
<p class="P_Normal">It’s Bobby Versailles’s senior year. Captain of his high school football team, he’s bound to win Homecoming King and hopefully a state championship, but he’s been miserable for years. His fear of somebody finding out he’s gay has brought isolation and loneliness. He has hidden that he’s gay by going on dates with girls now and then, and also by working out and excelling at football—which has also helped teachers look past his learning difficulties. When he first eyes Jacob, it’s possibly love at first sight. Bobby becomes a little obsessed. Jacob has got to be gay, and when Bobby makes a move, both of their worlds turn upside down!</p>
<p class="P_Normal">It’s 1982, and while the Nebraska Cornhuskers are barreling toward a possible NCAA National Football Championship, everyone in a small town two hours away hopes Bobby can lead them to a state championship. Can two teens with vastly different lives find love amidst the fervor of Nebraska football?</p>
<p class="P_Normal"> </p>
<p class="P_Normal"><span style=" font-style: italic; font-size: 1.00em;">States of Love: Stories of romance that span every corner of the United States.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?702045ff